module.exports = __webpack_public_path__ + "5ceef63ab2e1dd5774cdfa60b71a5bbb.png";